import styled from 'styled-components';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

export const CompanyInfoContainer = styled(Grid)`
  position: relative;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.x8spacePx}px;
  ${media.mdDown`
    padding: ${({ theme }) => `${theme.x2spacePx}px`};
    padding-bottom: ${({ theme }) => theme.x8spacePx}px;
  `}
`;

export const UpdatesContainer = styled(Grid)`
  margin-top: ${({ theme }) => theme.safeAreaInsetTop};
`;
